// --- BARRE BONUS DYNAMIQUE BIGFARMA ---
(function() {
  'use strict';
  
  // Configuration des paliers
  const palier1 = 0; // OCB et briquet
  const palier2 = 49; // 5G offerts
  const palier3 = 69; // Livraison gratuite
  const palier4 = 99; // 10G offerts
  
  const paliers = [palier1, palier2, palier3, palier4];
  
  // Messages pour chaque palier
  const messages = [
    'OCB et briquet offerts',
    '5G offerts',
    'livraison gratuite',
    '10G offerts'
  ];
  
  // Messages de succès
  const messagesSuccess = [
    '🍁 OCB et briquet offerts !',
    '🍄 Génial ! Tes 5G sont offerts !',
    '📦 Super ! Ta livraison est gratuite !',
    '🍄 Bravo ! Tes 10G offerts sont dans le panier !'
  ];
  
  // Messages CTA pour inciter à atteindre le prochain palier
  const messagesCTA = [
    '😎 Psst ! Ajoute {X} et tu recevras 5G offerts !',
    '😉 Encore {X} et ta livraison sera gratuite !',
    '🤩 Plus que {X} pour débloquer tes 10G offerts !'
  ];
  
  // Messages d'info pour les bonus obtenus
  const messagesInfo = [
    '🍁 Tu as déjà débloqué ton OCB et ton briquet gratuits !',
    '🍄 Profite de tes 5G offerts avec ta commande !',
    '📦 Ta livraison est gratuite, cool non ?',
    '🍄 Tes 10G offerts sont dans ton panier, profites-en !'
  ];
  
  /**
   * Met à jour la barre de progression et les messages
   * @param {object} cart - Objet panier de Shopify
   */
  function updateBonusBar(cart) {
    try {
      if (!cart || typeof cart.total_price !== 'number') return;
      
      // Calcul du montant en euros
      const montant = cart.total_price / 100;
      
      // Détermination du palier actuel
      let palierActuel = 0; // Par défaut OCB et briquet
      if (montant >= palier4) palierActuel = 3;
      else if (montant >= palier3) palierActuel = 2;
      else if (montant >= palier2) palierActuel = 1;
      
      // Détermination du prochain palier
      const estDernierPalier = palierActuel === 3;
      const prochainPalier = estDernierPalier ? null : palierActuel + 1;
      
      // Calcul du montant restant pour le prochain palier
      const prochainSeuil = prochainPalier !== null ? paliers[prochainPalier] : palier4;
      // Arrondir le montant restant à 2 décimales et s'assurer qu'il est toujours positif
      const montantRestantBrut = prochainPalier !== null ? (prochainSeuil - montant) : 0;
      const montantRestant = Math.max(0.01, montantRestantBrut).toFixed(2);
      
      // Calcul de la progression pour la barre
      const progression = Math.min(100, Math.round((montant * 100) / palier4));
      
      // Mise à jour de la barre de progression
      const progressBar = document.getElementById('bigfarma-progress-inner');
      if (progressBar) {
        progressBar.style.width = progression + '%';
        progressBar.style.display = 'block';
        progressBar.style.backgroundColor = '#18a957';
        progressBar.style.backgroundImage = 'linear-gradient(90deg, #18a957, #6dd88a)';
      }

      // Mise à jour du message principal
      const messageDiv = document.querySelector('.bigfarma-bonus-message');
      const bonusInfoDiv = document.querySelector('.bigfarma-bonus-info');
      
      if (messageDiv) {
        let newHtml = '';
        let newColor = '';
        let newWeight = '';
        let bonusInfoHtml = '';
        
        if (estDernierPalier) {
          // Message pour le dernier palier atteint (10G offerts)
          newHtml = messagesSuccess[palierActuel];
          newColor = '#18a957';
          newWeight = '700';
          bonusInfoHtml = messagesInfo[palierActuel];
        } else if (montantRestant <= 0) {
          // Message pour un palier atteint mais pas le dernier
          newHtml = messagesSuccess[palierActuel];
          newColor = '#18a957';
          newWeight = '700';
          bonusInfoHtml = messagesInfo[palierActuel];
        } else {
          // Message pour un palier en cours avec montant restant
          let ctaMessage = prochainPalier !== null ? messagesCTA[prochainPalier-1] : '';
          if (ctaMessage) {
            ctaMessage = ctaMessage.replace('{X}', `<span style="font-weight:700;color:#18a957;">${montantRestant} €</span>`);
            newHtml = ctaMessage;
          } else {
            newHtml = `Encore <span class="bonus-amount" style="font-weight:700;color:#18a957;">${montantRestant} €</span> pour débloquer <span style="color:#18a957;font-weight:600;">${messages[prochainPalier]}</span>`;
          }
          newColor = '';
          newWeight = '';
        }
        
        // Mise à jour du DOM uniquement si nécessaire
        if (messageDiv.innerHTML !== newHtml) {
          messageDiv.innerHTML = newHtml;
        }
        
        // Mise à jour du message d'info bonus en dessous
        if (bonusInfoDiv) {
          if (montantRestant <= 0) {
            // Si un palier est atteint, on affiche le message d'info correspondant
            bonusInfoDiv.innerHTML = messagesInfo[palierActuel];
            bonusInfoDiv.style.display = 'block';
            bonusInfoDiv.style.color = '#18a957';
            bonusInfoDiv.style.fontWeight = '600';
          } else if (bonusInfoHtml) {
            // Si on a un message CTA à afficher
            bonusInfoDiv.innerHTML = bonusInfoHtml;
            bonusInfoDiv.style.display = 'block';
            bonusInfoDiv.style.color = '';
            bonusInfoDiv.style.fontWeight = '';
          } else {
            bonusInfoDiv.style.display = 'none';
          }
        }
        
        if (messageDiv.style.color !== newColor) {
          messageDiv.style.color = newColor;
        }
        if (messageDiv.style.fontWeight !== newWeight) {
          messageDiv.style.fontWeight = newWeight;
        }
      }
      
      // Mise à jour des paliers visuels
      const palierNodes = document.querySelectorAll('.bigfarma-bonus-palier');
      if (palierNodes && palierNodes.length) {
        Array.prototype.forEach.call(palierNodes, function(node, idx) {
          try {
            const labelNode = node.querySelector('.bigfarma-bonus-palier-label');
            if (!labelNode) return;
            
            // Déterminer si le palier est débloqué et actif
            let estDebloque = false;
            let estActif = false;
            
            if (idx === 0) { // Premier palier (OCB et briquet)
              estDebloque = true; // Toujours débloqué
              estActif = palierActuel === 0;
            } else {
              const seuil = paliers[idx];
              estDebloque = montant >= seuil;
              estActif = palierActuel === idx;
            }
            
            // Mise à jour des classes CSS
            if (estDebloque) {
              node.classList.add('unlocked');
              node.classList.remove('locked');
            } else {
              node.classList.remove('unlocked');
              node.classList.add('locked');
            }
            
            if (estActif) {
              labelNode.classList.add('active');
            } else {
              labelNode.classList.remove('active');
            }
          } catch (e) {
            console.warn('Erreur sur palier visuel:', e);
          }
        });
      }
    } catch (err) {
      console.warn('Erreur dans updateBonusBar:', err);
    }
  }

  /**
   * Récupère les données du panier et met à jour l'interface
   */
  function fetchAndUpdateBonusBar() {
    try {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { updateBonusBar(cart); })
        .catch(function(err) { console.warn('Erreur fetch cart:', err); });
    } catch (err) {
      console.warn('Erreur fetchAndUpdateBonusBar:', err);
    }
  }

  /**
   * Initialisation avec détection optimisée des événements de panier
   */
  function init() {
    try {
      // Exécution immédiate
      fetchAndUpdateBonusBar();
      
      // Événements Shopify standard
      const shopifyEvents = ['cart:refresh', 'cart:updated', 'cart:change', 'cart:render', 'drawer:open'];
      shopifyEvents.forEach(function(evt) {
        document.addEventListener(evt, fetchAndUpdateBonusBar);
      });
      
      // Détection optimisée des interactions utilisateur
      const interactionSelectors = [
        '.quantity__button', '.quantity__input', '.cart-remove-button',
        '[data-cart-update]', '[data-cart-add]', '[data-cart-remove]'
      ];
      
      document.addEventListener('click', function(e) {
        // Vérifier si l'élément cliqué correspond à un sélecteur d'interaction
        const isCartInteraction = interactionSelectors.some(function(selector) {
          return e.target.matches && (e.target.matches(selector) || (e.target.closest && e.target.closest(selector)));
        });
        
        if (isCartInteraction) {
          // Utiliser requestAnimationFrame pour optimiser les performances
          setTimeout(function() {
            requestAnimationFrame(fetchAndUpdateBonusBar);
          }, 200);
        }
      });
      
      // MutationObserver optimisé
      const cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer && window.MutationObserver) {
        // Utiliser un système de debounce pour éviter les mises à jour trop fréquentes
        let debounceTimer;
        const debouncedUpdate = function() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(fetchAndUpdateBonusBar, 50);
        };
        
        const observer = new MutationObserver(function(mutations) {
          let shouldUpdate = false;
          
          // Analyse optimisée des mutations
          for (let i = 0; i < mutations.length; i++) {
            const mutation = mutations[i];
            
            // Vérifier si la mutation est pertinente pour le panier
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              shouldUpdate = true;
              break;
            }
            
            if (mutation.type === 'attributes' && 
                (mutation.attributeName === 'data-cart-count' || 
                 mutation.attributeName === 'data-cart-total')) {
              shouldUpdate = true;
              break;
            }
          }
          
          if (shouldUpdate) {
            debouncedUpdate();
          }
        });
        
        // Observer les changements dans le DOM
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-cart-count', 'data-cart-total']
        });
      }
      
      // Intégration avec l'API Shopify
      if (typeof window.Shopify !== 'undefined') {
        // Interception de onCartUpdate
        if (window.Shopify.onCartUpdate) {
          const originalOnCartUpdate = window.Shopify.onCartUpdate;
          window.Shopify.onCartUpdate = function() {
            try {
              originalOnCartUpdate.apply(this, arguments);
            } catch (e) {
              console.warn('Erreur dans originalOnCartUpdate:', e);
            }
            requestAnimationFrame(fetchAndUpdateBonusBar);
          };
        } else {
          window.Shopify.onCartUpdate = function() {
            requestAnimationFrame(fetchAndUpdateBonusBar);
          };
        }
      }
    } catch (err) {
      console.warn('Erreur initialisation barre bonus:', err);
    }
  }

  // Initialisation optimisée
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// --- FIN BARRE BONUS DYNAMIQUE ---
